import { useLocalSearchParams } from 'expo-router';
import { useForm } from 'react-hook-form';
import { StyleSheet, View } from 'react-native';

import { useUpdateNonProfitOrgWiki } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import BrandedButton from '@/components/buttons/BrandedButton';
import FormWrapper from '@/components/forms/FormWrapper';
import TextInputField from '@/components/inputs/TextInputField';
import OnboardingSection from '@/components/npo/onboarding/OnboardingSection';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';
import { useWikiChangesNpoModal } from '@/contexts/wikiChangesNpoModalContext';

const NpoBioWiki = () => {
  const { npoJson } = useLocalSearchParams<{ npoJson: string }>();
  const { mutateAsync: nonProfitUpdateWiki, isPending: nonProfitIsPending } = useUpdateNonProfitOrgWiki();

  const { showError } = useEndFlowModal();
  const { setVisible, setNpoId } = useWikiChangesNpoModal();

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoJson ?? '');

  const updateNonProfit = ({ description }: { description: string | undefined }) => {
    nonProfitUpdateWiki(
      {
        npoId: nonProfitOrg?.id ?? '',
        description: description
      },
      {
        onSuccess: (_) => {
          setNpoId(nonProfitOrg?.id ?? '');
          setVisible(true);
        },
        onError: (e) => {
          showError({ message: e.message });
          console.error('Error', e);
        }
      }
    );
  };

  const {
    control,
    handleSubmit,
    formState: { isValid, submitCount }
  } = useForm<{ description: string }>({
    defaultValues: { description: nonProfitOrg?.description },
    mode: 'onSubmit'
  });

  return (
    <FormWrapper>
      <View style={styles.container}>
        <OnboardingSection label={i18n.t('sign_in.nonProfit.general.name_section')}>
          <TextInputField
            control={control}
            name="description"
            multiline
            minHeight={120}
            maxHeight={120}
            placeholder={i18n.t('sign_in.nonProfit.general.description_placeholder')}
            returnKeyLabel="done"
            returnKeyType="done"
          />
        </OnboardingSection>
        <BrandedButton
          style={styles.doneButton}
          loading={nonProfitIsPending}
          disabled={!isValid && submitCount > 0}
          onPress={handleSubmit(updateNonProfit)}>
          {i18n.t('mix.done')}
        </BrandedButton>
      </View>
    </FormWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 25
  },

  doneButton: {
    width: '100%'
  }
});

export default NpoBioWiki;
